import { render, staticRenderFns } from "./DecimalFieldReadonly.vue?vue&type=template&id=04518d54&scoped=true"
import script from "./DecimalFieldReadonly.vue?vue&type=script&lang=ts"
export * from "./DecimalFieldReadonly.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04518d54",
  null
  
)

export default component.exports